import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalJornadasCpa = ({ toggleFunction, modalState }) => {
  const formLink = 'https://forms.gle/fmwz8kHZqqYhuiG77'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container modal-jornadas cards-center text-center'>
          <p className='heading-title fw-bold mb-2'>I Jornadas de Cirugía de Pared Abdominal</p>

          <p className='heading-subtitle fw-semibold fs-base mb-4'>División de Estudios para Graduados, Facultad de Medicina LUZ</p>

          <div className='info-group d-flex flex-column'>

            <div className='span-group icon'>
              <i className="bi bi-calendar-event icon"></i>
              <span className='span-title'>Fecha: </span>
              <span>25 y 26 de septiembre de 2026</span>
            </div>

            <div className='span-group icon'>
              <i className="bi bi-people-fill icon"></i>
              <span className='span-title'>Dirigido a: </span>
              <span> Residentes y Especialistas en Cirugía General</span>
            </div>

            <div className='span-group icon'>
              <i className="bi bi-geo-alt-fill icon"></i>
              <span className='span-title'>Lugar: </span>
              <span>Auditorio Dr. Antonio Borjas Romero, Facultad de Medicina</span>
            </div>

            <div className='colored-title mb-3'>
              <p className='fw-semibold mb-0'>Coordinador: Dr. Adolfo Brea Andrade</p>
            </div>

            <div className='callout-group'>
              <div className='question-callout lightblue info'>
                <i className="bi bi-calendar-check icon"></i>
                <div className='text-group'>
                  <p className='callout-title'>Asistencia sin costo</p>
                  <p className='callout-text'>Inscripción previa a través del formulario</p>
                </div>
              </div>

              <div className='question-callout lightblue info'>
                <i className="bi bi-file-check icon"></i>
                <div className='text-group'>
                  <p className='callout-title'>Certificado de Asistencia</p>
                  <p className='callout-text'>Opcional, con costo para quienes lo soliciten</p>
                </div>
              </div>

              <div className='question-callout lightblue info'>
                <i className="bi bi-1-circle-fill icon"></i>
                <div className='text-group'>
                  <p className='callout-title'>Unidad Crédito</p>
                </div>
              </div>
            </div>
            
            <Button className='link-button w-fit mx-auto mt-1' target='blank' as='a' variant='primary' href={formLink}>
              Formulario de Inscripción
            </Button>
          </div>

        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalJornadasCpa }